import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { Button, Drawer, Form, Spin, Steps } from 'antd';
import React, { useEffect, useState } from 'react';
import {
	accommodationSteps,
	displayFormats,
	Notification,
} from '../../../../config/Global';
import Message from '../../../../config/Message';
import MerchantComponent from './MerchantComponent';
import moment from 'moment';
import MerchantSubscriptionComponent from './MerchantSubscripionComponent';
import AddAccommodationDetail from './AddAccommodationDetail';

const AddComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const { AUTH, ACCOMMODATION, ROOT } = useStore();
	const { merchantDetail, subscriptionHistory, propertyDetail } =
		ACCOMMODATION;
	const [current, setCurrent] = useState(0);
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);
	const [formID, setFormID] = useState('MerchantForm');
	const [accommodationState, setAccommodationState] = useState(true);
	const [accommodationID, setAccommodationID] = useState(null);
	const [accommodationStep, setAccommodationStep] =
		useState(accommodationSteps);

	const handleMerchantSubmit = async (data) => {
		if (
			!merchantDetail ||
			(merchantDetail && merchantDetail.id !== data.eMerchantId)
		) {
			data['merchantName'] = data.eMerchantId[0];
			delete data.eMerchantId;
			setSaving(true);
			ACCOMMODATION.addMerchant(data)
				.then((data) => {
					if (typeof data !== 'string') {
						Notification.success({
							message: Message().CRUD.ADD('Merchant Detail'),
						});
						form.resetFields();
						setCurrent(1);
						setAccommodationStep((prev) => {
							const updatedArray = [...prev];
							updatedArray[0] = {
								...updatedArray[0],
								status: 'finish',
							};
							return updatedArray;
						});
						setAccommodationID(data.data);
						setFormID('MerchantSubscriptionForm');
						setDisabled(true);
					} else {
						Notification.error({
							message: data,
						});
					}
				})
				.catch((e) => {})
				.finally(() => setSaving(false));
		} else {
			data['id'] = data.eMerchantId;
			delete data.eMerchantId;
			ACCOMMODATION.EditMerchant({
				...data,
				merchantName: merchantDetail.merchantName,
				versionNo: merchantDetail.versionNo,
				isActive: merchantDetail.isActive,
			})
				.then(() => {
					Notification.success({
						message: Message().CRUD.UPDATE('Merchant Detail'),
					});
					form.resetFields();
					setCurrent(1);
					ACCOMMODATION.ReadMerchant(merchantDetail.id);
					setAccommodationStep((prev) => {
						const updatedArray = [...prev];
						updatedArray[0] = {
							...updatedArray[0],
							status: 'finish',
						};
						return updatedArray;
					});
					setAccommodationID(data.id);
					setFormID('MerchantSubscriptionForm');
					setDisabled(true);
				})
				.catch((e) => {
					const errorData = ROOT.assignErrorToInput(e);
					form.setFieldsValue({ error: errorData });
				})
				.finally(() => setSaving(false));
		}
	};

	const handleChange = () => {
		setAccommodationState(!accommodationState);
		if (formID === 'MerchantSubscriptionForm') {
			form.validateFields({ validateOnly: true })
				.then(() => {
					setDisabled(false);
				})
				.catch(() => {
					// setDisabled(true);
				});
		} else {
			setTimeout(() => {
				form.validateFields({ validateOnly: true })
					.then(async () => {
						setDisabled(false);
					})
					.catch((err) => {
						setDisabled(true);
					});
			});
		}
	};

	const handleMerchantSubscriptionSubmit = (data) => {
		data['eMerchantId'] = accommodationID;
		ACCOMMODATION.addMerchantSusbcription(data)
			.then((data) => {
				if (typeof data !== 'string') {
					Notification.success({
						message: Message().CRUD.ADD(
							'Merchant Subscription Detail'
						),
					});
					form.resetFields();
					setCurrent(2);
					setFormID('PropertyForm');
					setTempleStep((prev) => {
						const updatedArray = [...prev];
						updatedArray[0] = {
							...updatedArray[1],
							status: 'finish',
						};
						return updatedArray;
					});
				} else {
					Notification.error({
						message: data,
					});
				}
			})
			.catch((e) => {})
			.finally(() => setSaving(false));
	};

	const closeModal = () => {
		ACCOMMODATION.agGrid.api.resetColumnState();
		ACCOMMODATION.setupGrid(ACCOMMODATION.agGrid);
		form.resetFields();
		setDisabled(true);
		AUTH.lookupKeyList = [];
		AUTH.stateList = [];
		AUTH.cityList = [];
		AUTH.amenityList = [];
		setFormID('MerchantForm');
		ACCOMMODATION.merchantDetail = null;
		ACCOMMODATION.propertyDetail = null;
		ACCOMMODATION.merchantLookupList = [];
		ACCOMMODATION.roomCategoryDetail = null;
		setCurrent(0);
		onClose();
	};

	//tab change when edit
	const onTabChange = async (e) => {
		setCurrent(e);
		form.resetFields();
		if (e === 1) {
			setFormID('MerchantSubscriptionForm');
			setCurrent(1);
			ACCOMMODATION.getSubscriptionList();
			setAccommodationID(merchantDetail.id);
			if (subscriptionHistory.length === 0) {
				handleMerchantSubscription();
			}
		} else if (e === 2) {
			if (propertyDetail === null) {
				await handleAccommodationDetail();
			}
		} else if (e === 0 && merchantDetail) {
			setFormID('MerchantForm');
			form.setFieldsValue(merchantDetail);
		}
	};
	const handleMerchantSubscription = () => {
		setDisabled(true);
		if (merchantDetail && merchantDetail.id) {
			setAccommodationID(merchantDetail.id);
			setFormID('MerchantSubscriptionForm');
		}
		setCurrent(1);
	};
	const handleAccommodationDetail = () => {
		setDisabled(true);
		if (merchantDetail && merchantDetail.id) {
			setAccommodationID(merchantDetail.id);
			let data = ACCOMMODATION.getMerchantAccomodation(merchantDetail.id);
			ACCOMMODATION.propertyDetail = data;
		}
		setCurrent(2);
	};

	return (
		<Drawer
			title={
				visible === 'edit' ? 'Edit Accommodation' : 'Add Accommodation'
			}
			onClose={closeModal}
			open={visible}
			destroyOnClose
			width={'75%'}
			footer={
				<div style={{ textAlign: 'right' }}>
					{current < 2 && (
						<Button
							type="primary"
							key={1}
							disabled={disabled}
							htmlType="submit"
							loading={saving}
							form={formID}
						>
							{accommodationStep.length - 1 === current
								? 'Save & Submit'
								: 'Save & Next'}
						</Button>
					)}
					<Button
						key={2}
						onClick={closeModal}
						style={{ marginLeft: '20px' }}
					>
						Cancel
					</Button>
				</div>
			}
		>
			<Steps
				items={accommodationStep}
				current={current}
				onChange={(e) =>
					visible === 'edit'
						? onTabChange(e)
						: console.log('fill form data')
				}
				style={{
					marginBottom: 24,
				}}
			/>
			{current === 0 ? (
				<MerchantComponent
					id="MerchantForm"
					form={form}
					onFinish={handleMerchantSubmit}
					handleChange={handleChange}
					visible={visible}
				/>
			) : current === 1 ? (
				<MerchantSubscriptionComponent
					id="MerchantSubscriptionForm"
					form={form}
					merchantId={accommodationID}
					onFinish={handleMerchantSubscriptionSubmit}
					handleChange={handleChange}
				/>
			) : current === 2 ? (
				<AddAccommodationDetail merchantId={accommodationID} />
			) : null}
		</Drawer>
	);
});
export default AddComponent;
